module.exports = __webpack_public_path__ + "static/media/rock_beach.a794a5ef.jpg";